/* __next_internal_client_entry_do_not_use__ SearchProductImageClient auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { isFastly } from "@faire/web--source/common/images/optimizeImages";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useRenderTracing } from "@faire/web--source/common/tracing/useRenderTracing";
import React, { useContext } from "react";
import { ROWS_PER_BATCH } from "@faire/retailer/components/SearchProducts/SingleProductRowPlaceholder";
import { ProductImage } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/ProductTileImage";
import { searchPageProductTileImagePropsAdapter } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/search/searchPageProductTileImagePropsAdapter";
import { ProductPositioningContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/productTileContext";
import { ProductTileTypeContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/productTileTypeContext";
import { getValidImageOrPlaceholder } from "@faire/retailer/features/MarketplaceItems/ProductDetailsTile/getValidImageOrPlaceholder";
import { useValidateImage } from "@faire/retailer/features/MarketplaceItems/ProductDetailsTile/useValidateImage";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSearchPageLoggedOutBrandTileReviews } from "@faire/retailer/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/LoggedOutBrandTileReviews/useSearchPageLoggedOutBrandTileReviews";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
export var SearchProductImageClient = function(param) {
    var _param_data = param.data, productToken = _param_data.productToken, productName = _param_data.productName, image = _param_data.image, productSearchString = _param_data.productSearchString, spellCorrectedQuery = _param_data.spellCorrectedQuery;
    var endTrace = useRenderTracing("ProductTileImage", {
        productToken: productToken
    });
    var strictLocalize = useStrictLocalization().strictLocalize;
    var productTileType = useContext(ProductTileTypeContext).productTileType;
    var isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
    var reviews = useSearchPageLoggedOutBrandTileReviews().reviews;
    var productPositioningContext = React.useContext(ProductPositioningContext);
    var useLazyImageLoading = productPositioningContext.index !== undefined && productPositioningContext.itemsPerRow !== undefined && productPositioningContext.index >= productPositioningContext.itemsPerRow * ROWS_PER_BATCH;
    var primaryImage = image;
    var validImage = useValidateImage(image);
    if ((image === null || image === void 0 ? void 0 : image.url) && !isFastly(image.url)) {
        primaryImage = getValidImageOrPlaceholder(validImage);
    }
    var searchProductTileImageProps = searchPageProductTileImagePropsAdapter({
        productName: productName,
        strictLocalize: strictLocalize,
        productTileType: productTileType,
        productSearchString: productSearchString,
        spellCorrectedQuery: spellCorrectedQuery,
        isFromDiscoverURL: isFromDiscoverURL,
        reviews: reviews,
        shouldUseLazyImageLoading: useLazyImageLoading,
        showVerticalImagery: false,
        primaryImage: primaryImage,
        onLoad: endTrace
    });
    return /*#__PURE__*/ _jsx(ProductImage, {
        data: searchProductTileImageProps
    });
};
